import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CategorySearchDetails } from '../_models/category-search-details';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductSearchService {

  constructor(
    private http: HttpClient
  ) { }
  public static readonly GET_PRODUCT_BY_SEARCH_KEYWORDS = environment.apiURL + 'getProductBySearchKeyword/';


  getProductBySearchKeyword(categoryId: Number, searchKeyword: String,userId:any): Observable<CategorySearchDetails> {
    let params = "?categoryId=" +categoryId +"&searchKeyword=" + searchKeyword+"&userId="+userId;
    return this.http.get<CategorySearchDetails>(ProductSearchService.GET_PRODUCT_BY_SEARCH_KEYWORDS + params)
      .pipe(map(response => {
        return response;
      }));
  }

}
